export default "__VITE_ASSET__BIAAD9TJ__"